import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Input, Flex, Empty } from 'antd';
import { FileSearchOutlined, MinusOutlined } from '@ant-design/icons';
import { useProductPaymentAdditionalInformationDispatch } from '../context/ProductPaymentAdditionalInformationProvider';
import MessageAlert from 'utils';
const ProductPaymentAdditionalInformation = ({
  defaultData,
  editMode,
  onChange,
}) => {
  /* ===== Init ===== */
  const dispatch = useProductPaymentAdditionalInformationDispatch();
  /* ===== STATE ===== */
  const [data, setData] = useState([]); // 초기값을 빈 배열로 설정

  const [inputKey, setInputKey] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [isAdding, setIsAdding] = useState(false); // 입력창 표시 여부
  /* ===== FUNCTION ===== */
  /**
   * 추가 함수
   */
  const handleAdd = () => {
    if (!inputKey || !inputValue) {
      MessageAlert.error('타이틀 또는 설명이 비어있습니다.');
      return;
    }

    // 같은 키가 이미 존재하는지 확인
    const isDuplicate = data.some((item) => item.key === inputKey);

    if (isDuplicate) {
      MessageAlert.error('똑같은 이름의 타이틀이 이미 존재합니다.');
      return; // 중복된 키가 있으면 추가하지 않음
    }

    const newData = [
      ...data,
      { index: data.length, key: inputKey, value: inputValue },
    ];
    setData(newData);
    dispatch({ type: 'SET_PAYMENT_ADDITIONAL_INFO', value: newData });
    setInputKey('');
    setInputValue('');
    // setIsAdding(false);
  };

  /**
   * 삭제 함수
   */
  const handleRemove = (index) => {
    setData(data.filter((item) => item.index !== index));
  };

  /**
   * 키 변경 함수 (순서 유지)
   */
  const handleKeyChange = (index, newKey) => {
    if (!newKey) return;
    setData(
      data.map((item) =>
        item.index === index ? { ...item, key: newKey } : item
      )
    );
  };

  /**
   * 값 변경 함수 (순서 유지)
   */
  const handleValueChange = (index, newValue) => {
    setData(
      data.map((item) =>
        item.index === index ? { ...item, value: newValue } : item
      )
    );
  };

  /* ===== HOOKS ===== */
  // 데이터 변경 시 상태와 dispatch 업데이트
  useEffect(() => {
    const objData =
      data.length > 0
        ? Object.fromEntries(
            data.map((item, index) => [
              index,
              { key: item.key, value: item.value },
            ])
          )
        : null;
    onChange(objData);
    dispatch({ type: 'SET_PAYMENT_ADDITIONAL_INFO', value: data });
  }, [data, onChange, dispatch]);

  useEffect(() => {
    if (defaultData && defaultData?.payment_additional_information) {
      const updatedData = Object.entries(
        defaultData?.payment_additional_information
      ).map(([key, value], index) => ({ index, key, value }));
      setData(updatedData);
    }
  }, [defaultData]); // defaultData가 변경될 때마다 실행

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Flex justify="space-between" style={{ marginBottom: 10 }}>
        <Title size={5} align="left">
          <FileSearchOutlined /> 부가 정보
        </Title>
        {editMode && !isAdding && (
          <Button type={'primary'} onClick={() => setIsAdding(true)}>
            추가
          </Button>
        )}
      </Flex>
      <br />
      {isAdding && (
        <Flex gap={8} style={{ marginBottom: 10 }}>
          <Input
            value={inputKey}
            placeholder="타이틀 입력"
            style={{ width: '25%' }}
            onChange={(e) => setInputKey(e.target.value)}
          />
          <Input
            value={inputValue}
            style={{ width: '75%' }}
            placeholder="설명 입력"
            onChange={(e) => setInputValue(e.target.value)}
          />
          <Button type={'primary'} onClick={handleAdd}>
            저장
          </Button>
        </Flex>
      )}
      {data.length ? (
        <>
          {data.map(({ index, key, value }) => (
            <Flex
              key={index}
              gap={8}
              align="center"
              style={{ marginBottom: 8 }}
            >
              <Input
                value={key}
                disabled={!editMode}
                style={{ flex: 1 }}
                onChange={(e) => handleKeyChange(index, e.target.value)}
              />
              <Input
                value={value}
                disabled={!editMode}
                style={{ flex: 2 }}
                onChange={(e) => handleValueChange(index, e.target.value)}
              />
              {editMode && (
                <Button
                  danger
                  onClick={() => {
                    handleRemove(index);
                    if (data?.length - 1 === 0) setIsAdding(false);
                  }}
                  icon={<MinusOutlined />}
                />
              )}
            </Flex>
          ))}
        </>
      ) : (
        <Empty />
      )}
    </Content>
  );
};

ProductPaymentAdditionalInformation.defaultProps = {
  onChange: () => {},
  editMode: false,
  defaultData: null,
};

export default ProductPaymentAdditionalInformation;
